import type EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { callEditorApi } from 'owa-editor/lib/utils/callEditorApi';
import { getIsDarkTheme } from 'owa-fabric-theme';

export function getIsDarkMode(editorViewState: EditorViewState, containerDiv?: HTMLDivElement) {
    if (containerDiv) {
        return getIsDarkTheme();
    }
    // callEditorApi will return undefined if editor is not mounted. In that case we treat it as light mode.
    return (editorViewState && callEditorApi(editorViewState, 'isDarkMode')) || false;
}
